import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'antd/dist/antd.variable.min.css';

import FormGenerator from './pages';

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
        <FormGenerator />
    </ConfigProvider>,
    document.getElementById('root')
);
